import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const googleCalendarApi = createApi({
  reducerPath: "appointmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/google/`,
    prepareHeaders: (headers, { getState }) => {
      const cookies = document.cookie.split(";");
      let jwtCookie = null;

      // `.trim().startsWith("token=")` pins to the exact cookie name —
      // `.includes("token=")` would also match `refresh_token=`,
      // `g_csrf_token=`, `xsrf_token=`, etc. and overwrite the real JWT
      // when one of those sits after `token=` in document.cookie.
      cookies.map((cookie) => {
        const c = cookie.trim();
        if (c.startsWith("token=")) {
          jwtCookie = "Bearer " + c.slice("token=".length);
        }
        return null;
      });

      if (jwtCookie) {
        headers.set("authorization", jwtCookie);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    createGoogleTokens: builder.mutation({
      query: (body) => ({
        url: `/create-tokens`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useCreateGoogleTokensMutation } = googleCalendarApi;
